import { render, staticRenderFns } from "./DialogCreateTest.vue?vue&type=template&id=72eddd28"
import script from "./DialogCreateTest.vue?vue&type=script&lang=js"
export * from "./DialogCreateTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports